import { comparisonData } from "@/mocks/categories";

export default function ComparisonTable() {
  const renderCell = (val: boolean | string) => {
    if (typeof val === "boolean") {
      return val ? (
        <i className="ri-check-line text-accent-500 text-lg"></i>
      ) : (
        <i className="ri-close-line text-foreground-300 text-lg"></i>
      );
    }
    return <span className="text-sm text-foreground-600 font-medium">{val}</span>;
  };

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 text-center mb-2">
          Shopping Agent Spreadsheet Comparison
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-8 max-w-xl mx-auto">
          Compare spreadsheet availability across the top four shopping agents to find the best fit for your needs.
        </p>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b border-foreground-200">
                <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-700">Category</th>
                <th className="text-center py-3 px-4 text-sm font-semibold text-primary-600">CSSBuy</th>
                <th className="text-center py-3 px-4 text-sm font-semibold text-foreground-700">Kakobuy</th>
                <th className="text-center py-3 px-4 text-sm font-semibold text-foreground-700">Superbuy</th>
                <th className="text-center py-3 px-4 text-sm font-semibold text-foreground-700">Oopbuy</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row) => (
                <tr key={row.category} className="border-b border-foreground-100 hover:bg-background-50 transition-colors duration-150">
                  <td className="py-3 px-4 text-sm font-medium text-foreground-800">{row.category}</td>
                  <td className="text-center py-3 px-4">{renderCell(row.cssbuy)}</td>
                  <td className="text-center py-3 px-4">{renderCell(row.kakobuy)}</td>
                  <td className="text-center py-3 px-4">{renderCell(row.superbuy)}</td>
                  <td className="text-center py-3 px-4">{renderCell(row.oopbuy)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}